import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class SiteContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [
                {
                    id: 1,
                    text01: 'At K.LIZZ Classic Hardware, we pride ourselves on stocking only the highest quality building materials from trusted brands. Our extensive inventory includes premium plywood, MDF boards, block boards, and chip boards in all standard sizes to meet your construction and furniture-making needs.',
                    text02: 'We understand that quality matters in construction. That\'s why we partner with leading manufacturers like Blue Triangle, Nguvi, Seweco, Cona, and Valida to ensure you get reliable products that stand the test of time. Visit our Nairobi location to see our wide range of materials firsthand.'
                },
                {
                    id: 2,
                    text01: 'Our team of experienced professionals is committed to helping you find exactly what you need for your project. Whether you\'re a contractor working on a large development or a homeowner tackling a DIY project, we provide personalized service and expert advice.',
                    text02: 'We maintain large stocks to ensure product availability and can arrange bulk orders for commercial projects. Our competitive pricing and quality guarantee make us the preferred choice for builders, contractors, and woodworkers throughout Nairobi and beyond.'
                },
                {
                    id: 3,
                    text01: 'K.LIZZ Classic Hardware is committed to being your one-stop shop for all building materials and hardware needs. We continuously update our inventory to include the latest products and innovations in the construction industry.',
                    text02: 'From foundation to finishing touches, we have everything you need. Our commitment to customer satisfaction, combined with our extensive product knowledge and competitive prices, ensures that your project succeeds. Contact us today to discuss your requirements.'
                }
            ]
        }
    }
    
    render() {
        return (
            <div id="site-content" className="site-content clearfix">
                <div id="inner-content" className="inner-content-wrap">
                    <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={60} data-smobile={60} />
                    <div className="themesflat-row equalize sm-equalize-auto clearfix">
                        <div className="span_1_of_6 bg-f7f">
                            <div className="themesflat-spacer clearfix" data-desktop={60} data-mobile={60} data-smobile={60} />
                            <div className="themesflat-content-box clearfix" data-margin="0 10px 0 43px"
                                data-mobilemargin="0 15px 0 15px">
                                <div className="themesflat-headings style-2 clearfix">
                                    <div className="sup-heading">QUALITY MATERIALS</div>
                                    <h2 className="heading font-size-28 line-height-39">PLYWOOD &amp; BOARDS</h2>
                                    <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                                    <p className="sub-heading margin-top-33 line-height-24">We stock premium plywood in 3mm, 6mm, and 9mm sizes, MDF boards, marine boards, block boards, and chip boards. All our products meet international quality standards for durability and performance.</p>
                                </div>
                            </div>
                            <div className="themesflat-spacer clearfix" data-desktop={56} data-mobile={56} data-smobile={56} />
                        </div>
                        <div className="span_1_of_6 half-background style-2">
                        </div>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={39} data-mobile={39} data-smobile={39} />
                    <div className="flat-content-wrap style-2 clearfix">
                        <h5 className="title">PRODUCT EXPERTISE</h5>
                        <p>K.LIZZ Classic Hardware provides comprehensive building material solutions for contractors, builders, and homeowners in Nairobi. We understand your construction needs and offer expert guidance in selecting the right materials for your project. Our tagline "WE FLOW WITH QUALITIES" reflects our commitment to stocking only premium products from trusted manufacturers. With years of experience in the hardware industry, we've built a reputation for reliability, quality, and competitive pricing. Our knowledgeable staff can help you choose the perfect materials, whether you're building a new home, renovating, or working on custom furniture projects.
                        </p>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={37} data-mobile={35} data-smobile={35} />
                    <div className="flat-content-wrap style-2 clearfix">
                        <div className="item">
                            <div className="inner">
                                <div className="themesflat-spacer clearfix" data-desktop={10} data-mobile={10} data-smobile={10} />
                                <h5 className="title">OUR PRODUCT RANGE INCLUDES:</h5>
                                <p>We have successfully served thousands of customers across Nairobi with quality building materials. K.LIZZ Classic Hardware offers a comprehensive inventory of:</p>
                                <div className="themesflat-spacer clearfix" data-desktop={8} data-mobile={8} data-smobile={8} />
                                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                                    <div className="inner">
                                        <span className="item">
                                            <span className="icon"><i className="fa fa-check-circle" /></span>
                                            <span className="text">Plywood (3mm, 6mm, 9mm) & MDF Boards</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                                    <div className="inner">
                                        <span className="item">
                                            <span className="icon"><i className="fa fa-check-circle" /></span>
                                            <span className="text">Block Boards, Chip Boards & Marine Boards</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                                    <div className="inner">
                                        <span className="item">
                                            <span className="icon"><i className="fa fa-check-circle" /></span>
                                            <span className="text">Flash Doors, Mahogany Doors & Hardware</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                                    <div className="inner">
                                        <span className="item">
                                            <span className="icon"><i className="fa fa-check-circle" /></span>
                                            <span className="text">Paints, Adhesives, Tools & Fasteners</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                            <div className="themesflat-content-box clearfix" data-margin="0 0 0 11px" data-mobilemargin="0 0 0 0">
                                <div className="inner pd35 bg-ffc">
                                    <h5 className="title text-white line-height-24 padding-left-7">DOWNLOAD OUR COMPLETE PRODUCT CATALOG AND PRICE LIST</h5>
                                    <div className="themesflat-spacer clearfix" data-desktop={16} data-mobile={16}
                                        data-smobile={16} />
                                    <div className="button-wrap has-icon icon-right size-14">
                                        <Link to="#"
                                            className="themesflat-button bg-white color-333 w100 font-weight-400 no-letter-spacing pd26"><span>Product Catalog
                                                <span className="icon"><i className="fa fa-file-pdf-o" /></span></span></Link>
                                    </div>
                                    <div className="themesflat-spacer clearfix" data-desktop={6} data-mobile={6} data-smobile={6} />
                                    <div className="button-wrap has-icon icon-right size-14">
                                        <Link to="#"
                                            className="themesflat-button bg-white color-333 w100 font-weight-400 no-letter-spacing pd26 "><span>
                                                Price List <span className="icon"><i
                                                        className="fa fa-file-word-o" /></span></span></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={37} data-mobile={35} data-smobile={35} />
                    <div className="flat-content-wrap style-2 clearfix">
                        <h5 className="title no-letter-spacing">CONTACT K.LIZZ CLASSIC HARDWARE TODAY</h5>
                        <div className="themesflat-spacer clearfix" data-desktop={27} data-mobile={27} data-smobile={27} />
                        <div className="themesflat-tabs style-2 title-w170 clearfix">
                            <ul className="tab-title clearfix ">
                                <li className="item-title active">
                                    <span className="inner">Quality Focus</span>
                                </li>
                                <li className="item-title">
                                    <span className="inner">Customer Service</span>
                                </li>
                                <li className="item-title">
                                    <span className="inner">Our Commitment</span>
                                </li>
                            </ul>
                            <div className="tab-content-wrap clearfix">
                                {
                                    this.state.tabs.map(data =>(
                                        <div className="tab-content" key={data.id}>
                                            <div className="item-content">
                                                <p>{data.text01}</p>
                                                <p>{data.text02}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={60} data-smobile={60} />
                </div>
            </div>
        );
    }
}

export default SiteContent;